import { Controller, useFormContext } from 'react-hook-form';

import Checkbox from '@mui/material/Checkbox';
import FormGroup from '@mui/material/FormGroup';
import FormLabel from '@mui/material/FormLabel';
import FormControl from '@mui/material/FormControl';
import FormHelperText from '@mui/material/FormHelperText';
import FormControlLabel from '@mui/material/FormControlLabel';
import React from 'react';

// ----------------------------------------------------------------------

export const RHFCheckbox = React.memo(({ name = "", helperText, className = "", ...other }) => {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => (
        <div className={className}>
          <FormControlLabel control={<Checkbox {...field} checked={!!field.value} sx={{
            ".MuiSvgIcon-root": field.value  ? {
              fill:'#00B8D9'
            } :{}
          }}/>} {...other} />

          {(!!error || helperText) && (
            <FormHelperText error={!!error}>{error ? error?.message : helperText}</FormHelperText>
          )}
        </div>
      )}
    />
  );
});
